// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

import DashboardGridController from "./dashboard_grid_controller"
application.register("dashboard-grid", DashboardGridController)

import DashboardRefreshController from "./dashboard_refresh_controller"
application.register("dashboard-refresh", DashboardRefreshController)

import DashboardWidgetBuilderController from "./dashboard_widget_builder_controller"
application.register("dashboard-widget-builder", DashboardWidgetBuilderController)

import DeleteConfirmationController from "./delete_confirmation_controller"
application.register("delete-confirmation", DeleteConfirmationController)

import EmailDecoderController from "./email_decoder_controller"
application.register("email-decoder", EmailDecoderController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LiveChartController from "./live_chart_controller"
application.register("live-chart", LiveChartController)

import LiveListController from "./live_list_controller"
application.register("live-list", LiveListController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import PageViewBeaconController from "./page_view_beacon_controller"
application.register("page-view-beacon", PageViewBeaconController)

import ScrollableRegionController from "./scrollable_region_controller"
application.register("scrollable-region", ScrollableRegionController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
